import {
    MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION,
    MUTATION_DEBOUNCE_MAX_DURATION,
} from '../../debounce';
import useDebouncedState from '../../useDebouncedState';
import { useUpdateField } from '../../useUpdateField';
import { useBriefSetReferenceProjectsMutation } from './referenceProjects.generated';

function useUpdateReferenceProjects(key: string, briefId?: string, initialValue?: string) {
    const [setReferenceProjects] = useBriefSetReferenceProjectsMutation();

    return useDebouncedState(
        useUpdateField({
            key,
            setField: setReferenceProjects,
            briefId,
            initialValue,
        }),
        MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION,
        MUTATION_DEBOUNCE_MAX_DURATION
    );
}

export default useUpdateReferenceProjects;
